<label class="fieldset-label select-none">
  <input
    [(ngModel)]="checked"
    type="checkbox"
    checked="checked"
    class="checkbox rounded"
    [ngClass]="[colorClasses[color()].checkbox, colorClasses[color()].border, sizeClasses[size()]]" />
  @if (label(); as label) {
    <p class="text-gray-800 font-normal text-sm">{{ label }}</p>
  }
</label>
